module.exports = __webpack_public_path__ + "static/media/people.47376337.svg";